export default __webpack_public_path__ + "static/media/careersIllustration.5daec2ef.svg";